import { render } from "./ControlItem.vue?vue&type=template&id=40af0d0c&scoped=true"
import script from "./ControlItem.vue?vue&type=script&lang=js"
export * from "./ControlItem.vue?vue&type=script&lang=js"

import "./ControlItem.vue?vue&type=style&index=0&id=40af0d0c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40af0d0c"]])

export default __exports__